import React from "react";

export function FacebookInstruction() {
    return <span>
        Connect Facebook once, choose the Page you manage, and posts will be published as that Page.
    </span>
}
